"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var react_2 = require("@emotion/react");

var polished_1 = require("polished");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var enums_1 = require("../enums");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var content_1 = require("./content");

var enums_2 = require("../enums");

var radius = "50px";
var ButtonEdgeList = {
  LeftEdged: "".concat(radius, " 0 0 ").concat(radius),
  Rectangle: "0",
  RightEdged: "0 ".concat(radius, " ").concat(radius, " 0")
};
var Button = styled_1.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var index = props.index,
      theme = props.theme,
      white = props.white,
      inputHeight = props.inputHeight,
      color = props.color,
      textColor = props.textColor,
      disabledColor = props.disabledColor,
      options = props.options,
      border = props.border,
      isMobile = props.isMobile;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tmargin-top: 0px !important;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tflex-grow: 1;\n\t\t\tborder-radius: ", ";\n\t\t\tbackground-color: ", ";\n\t\t\theight: ", ";\n\t\t\tcolor: ", ";\n\t\t\tborder: none;\n\t\t\tborder-left: ", ";\n\t\t\tborder-right: ", ";\n\t\t\tborder-bottom: ", ";\n\t\t\tborder-top: ", ";\n\t\t\tcursor: pointer;\n\t\t\tpadding: ", ";\n\t\t\t&:hover {\n\t\t\t\tbackground-color: ", ";\n\t\t\t}\n\t\t\t&:disabled {\n\t\t\t\tbackground-color: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\tcursor: default;\n\t\t\t}\n\t\t"])), index === 0 ? ButtonEdgeList.LeftEdged : index === options.length - 1 ? ButtonEdgeList.RightEdged : ButtonEdgeList.Rectangle, color, inputHeight, textColor, border && index === 0 ? "1px solid ".concat(theme.colors.primary.lightGray) : "none", index !== options.length - 1 ? "1px solid rgba(255,255,255, 0.1)" : border ? "1px solid ".concat(theme.colors.primary.lightGray) : "none", border ? "1px solid ".concat(theme.colors.primary.lightGray) : "none", border ? "1px solid ".concat(theme.colors.primary.lightGray) : "none", isMobile ? "0 10px" : "0 20px", (0, polished_1.mix)(0.65, "".concat(theme.colors.primary.lightGray), white), disabledColor, white);
});
var ButtonLabel = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var theme = props.theme;
  return (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\tfont-family: ", ";\n\t\t\tfont-size: ", ";\n\t\t\tpadding-left: 8px;\n\t\t"])), theme.typography.fontFamilies.primary, theme.typography.fonts.sizes.sm.size);
});
var ErrorContainer = styled_1.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tmargin-top: 10px;\n\tmargin-bottom: 8px;\n"])));

var ToggleButton = function ToggleButton(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "toggleBtn" : _ref$className,
      color = _ref.color,
      iconColor = _ref.iconColor,
      name = _ref.name,
      onChange = _ref.onChange,
      options = _ref.options,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      textColor = _ref.textColor,
      value = _ref.value,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      inputRef = _ref.inputRef,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? false : _ref$border,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? true : _ref$isValid,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      id = _ref.id,
      dataTestId = _ref.dataTestId,
      language = _ref.language,
      isMobile = _ref.isMobile;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var fontSize = theme.typography.fonts.sizes.md.size;
  var _theme$colors$primary = theme.colors.primary,
      errorColor = _theme$colors$primary.error,
      white = _theme$colors$primary.white,
      darkGray = _theme$colors$primary.darkGray;
  var disabledColor = theme.colors[type].disable;
  var labelColor = theme.colors[type].label;
  var inputHeight = enums_1.InputHeight[size];
  color = color ? color : darkGray;
  iconColor = iconColor ? iconColor : white;
  textColor = textColor ? textColor : white;
  var selectedBtn = (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t\tpointer-events: none;\n\t"])), theme.colors.primary.primaryBrand, white);
  var Label = styled_1.default.label(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\tdisplay: block;\n\t\tfont-size: ", ";\n\t\tmargin-bottom: ", ";\n\t\tcolor: ", ";\n\t\tline-height: 22px;\n\t"])), fontSize, enums_2.LabelBottomMargin[size], labelColor);

  var onSelect = function onSelect(toggleButton) {
    onChange(toggleButton.value);
  };

  var _react_1$default$useS = react_1.default.useState(),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      error = _react_1$default$useS2[0],
      setError = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    var _a;

    !isValid && required && setError((_a = content_1.content[language]) === null || _a === void 0 ? void 0 : _a.validation.selectOne);
  }, [isValid]);
  return (0, jsx_runtime_1.jsxs)("div", {
    "data-testid": dataTestId,
    children: [label && (0, jsx_runtime_1.jsxs)(Label, {
      tabIndex: -1,
      htmlFor: id,
      style: {
        color: labelColor
      },
      children: [label, required && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        color: errorColor,
        children: " *"
      })]
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      children: options && options.map(function (toggleButton, index) {
        return (0, jsx_runtime_1.jsx)(Button, {
          id: id,
          className: className,
          value: value,
          name: name,
          css: toggleButton.value === value && selectedBtn,
          ref: inputRef,
          onClick: function onClick(event) {
            onSelect(toggleButton);
            event.preventDefault();
          },
          tabIndex: tabIndex,
          disabled: toggleButton.disabled,
          "aria-disabled": toggleButton.disabled ? true : false,
          "data-testid": toggleButton.dataTestId,
          index: index,
          theme: theme,
          white: white,
          inputHeight: inputHeight,
          color: color,
          textColor: textColor,
          disabledColor: disabledColor,
          options: options,
          border: border,
          isMobile: isMobile,
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            css: (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding-right: 10px;\n\t\t\t\t\t\t\t\t"]))),
            alignItems: "center",
            children: [toggleButton.icon && (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
              size: "xs",
              icon: toggleButton.icon,
              onClick: function onClick() {
                return onSelect(toggleButton);
              },
              color: iconColor,
              disabled: toggleButton.disabled,
              disabledColor: white,
              "data-testid": dataTestId
            }), (0, jsx_runtime_1.jsx)(ButtonLabel, {
              theme: theme,
              children: toggleButton.display
            })]
          })
        }, toggleButton.value);
      })
    }), !isValid && (0, jsx_runtime_1.jsx)(ErrorContainer, {
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "md",
        color: type !== "tertiary" ? errorColor : (0, polished_1.mix)(0.2, errorColor, white),
        children: error
      })
    })]
  });
};

ToggleButton.displayName = "ToggleButton";
exports.default = ToggleButton;